import { OriginalDT } from './displayTypes/original'
import { CardDT } from './displayTypes/card'
import { V2 } from '@eventr/common'
import { PlainDT } from './displayTypes/list'

interface IUniversalRendererProps {
    data: V2
    screenType: string
}

export const UniversalRenderer = ({
    data,
    screenType = 'personal',
}: IUniversalRendererProps): JSX.Element => {
    const displayType = data.rendererOptions?.settings?.displayType

    switch (displayType) {
        case 'card':
            return <CardDT data={data} screenType={screenType} />
        case 'plain':
            return <PlainDT data={data} screenType={screenType} />
        case 'original':
        default:
            return <OriginalDT data={data} />
    }
}

export default UniversalRenderer
